import React from "react";
import logoConfimea from "../../images/parcerias/confirmea.jpg";
import logoExtraconomy from "../../images/logo-color-horizontal.png";
import logoBusinessSquare from "../../images/confimea-imprese.png";
import localeText from "../../../locale";

const ConfimeaHeader = () => {
  return (
    <header className="confimea-header">
      <div className="confimea-container">
        <div className="confimea-header-inner">
          <div className="confimea-header-logos">
            {/* <div className="flex gap-4">
              <img
                src={logoConfimea}
                alt="Confimea Imprese"
                style={{ height: "36px", objectFit: "contain" }}
              />
              <img src={logoExtraconomy} alt="Extraconomy" />
            </div>

            <span
              className="hidden md:block"
              style={{
                display: "inline-block",
                width: "1px",
                height: "24px",
                background: "#E5E7EB",
                margin: "0 12px",
                verticalAlign: "middle",
              }}
            ></span>
            <span className="text-sm text-gray-500 hidden md:block">
              {localeText("headerPartnership")}
            </span> */}
            <img
              src={logoBusinessSquare}
              alt="Business Square"
              style={{ height: "46px", objectFit: "contain" }}
            />
          </div>

          <nav className="confimea-header-nav">
            <a href="#faq" className="flex items-center gap-2">
              <i className="pi pi-question-circle"></i>
              {localeText("headerHelp")}
            </a>
            <a href="https://confimea.com/" target="_blank" rel="noreferrer">
              {localeText("headerBackToConfimea")}
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default ConfimeaHeader;
